import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown, Phone } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const services = ['Movilidad Internacional', 'Contabilidad y Fiscalidad', 'Asesoría Mercantil', 'Asesoría Laboral'];
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-159">
      <div className="container mx-auto px-4 md:px-6" data-id="element-160">
        <div className="flex items-center justify-between" data-id="element-161">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-162">
            <img src="https://cdn.magicpatterns.com/uploads/m833YbxveJrgayp441DGvm/NETCG.png" alt="NETCG & ASOCIADOS Logo" className="h-10 md:h-12 w-auto object-contain" data-id="element-163" />
            <span className={`font-bold text-xl hidden sm:block ${isScrolled ? 'text-navy' : 'text-white'}`} data-id="element-164">
              NETCG & ASOCIADOS
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-165">
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className={`text-sm font-medium hover:text-primary transition-colors ${isScrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-166">
              Inicio
            </button>

            <div className="relative group" data-id="element-167">
              <button className={`flex items-center gap-1 text-sm font-medium hover:text-primary transition-colors ${isScrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-168">
                Servicios <ChevronDown className="w-4 h-4" data-id="element-169" />
              </button>

              {/* Dropdown */}
              <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all transform translate-y-2 group-hover:translate-y-0 p-2" data-id="element-170">
                {services.map(service => <button key={service} onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-primary rounded-lg transition-colors" data-id="element-171">
                    {service}
                  </button>)}
              </div>
            </div>

            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium hover:text-primary transition-colors ${isScrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-172">
              Casos de éxito
            </button>
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-173">
            <Button size="sm" className="hidden md:flex" onClick={() => scrollToSection('contact')} data-id="element-174">
              Agendar llamada
            </Button>

            <button className={`md:hidden p-2 rounded-lg ${isScrolled ? 'text-gray-900' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-175">
              {isMobileMenuOpen ? <X data-id="element-176" /> : <Menu data-id="element-177" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-178">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-179">
            <div className="container mx-auto px-4 py-6 flex flex-col gap-4" data-id="element-180">
              <button onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            setIsMobileMenuOpen(false);
          }} className="text-left font-medium text-gray-900 py-2" data-id="element-181">
                Inicio
              </button>

              <div className="py-2" data-id="element-182">
                <button onClick={() => setIsServicesOpen(!isServicesOpen)} className="flex items-center justify-between w-full font-medium text-gray-900" data-id="element-183">
                  Servicios{' '}
                  <ChevronDown className={`w-4 h-4 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`} data-id="element-184" />
                </button>
                {isServicesOpen && <div className="pl-4 mt-2 space-y-2 border-l-2 border-gray-100 ml-1" data-id="element-185">
                    {services.map(service => <button key={service} onClick={() => scrollToSection('services')} className="block w-full text-left py-2 text-sm text-gray-600" data-id="element-186">
                        {service}
                      </button>)}
                  </div>}
              </div>

              <button onClick={() => scrollToSection('testimonials')} className="text-left font-medium text-gray-900 py-2" data-id="element-187">
                Casos de éxito
              </button>

              <Button className="w-full mt-4" onClick={() => scrollToSection('contact')} data-id="element-188">
                Agendar llamada
              </Button>

              <div className="flex items-center justify-center gap-2 text-gray-500 text-sm mt-4" data-id="element-189">
                <Phone className="w-4 h-4" data-id="element-190" />
                <a href="tel:+34618940149" data-id="element-191">+34 618 940 149</a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}